/**
 * Returns an array of values from nested drill down options provided
 * @param headOptions Array of options to get values from
 * @returns values: string[]
 */
export function getAllValues(headOptions) {
    let options = null;
    const values = [];
    const stack = [headOptions];
    while ((options = stack.pop())) {
        options.forEach((option) => {
            if (option.value) {
                values.push(option.value);
            }
            if (option.options.length > 0) {
                stack.push(option.options);
            }
        });
    }
    return values;
}
